import React from 'react'
import {Select} from "antd"

const {Option} = Select

const SelectSearch = (props) => {
    const {listSelect, name, value, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="InputSearch">
            <label htmlFor={name}>{label}</label>

            <Select
                showSearch
                id={name}
                style={{width: '100%'}}
                defaultValue=""
                value={value}
                onChange={_handleChangeSelect}
                placeholder="Please select"
                allowClear
                filterOption={
                    (input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                <Option value=''>All</Option>
                {
                    listSelect.map(item => {
                        return <Option value={item.id} key={item.id}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default SelectSearch
